var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWebsite = function SvgWebsite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M15 1.5H3V9H1.5V.75A.75.75 0 0 1 2.25 0h13.5a.75.75 0 0 1 .75.75V9H15V1.5Zm-8.25 9.75h4.5v-.75H18V12a.75.75 0 0 1-.75.75H.75A.75.75 0 0 1 0 12v-1.5h6.75v.75Z"
  })));
};
export default SvgWebsite;